var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9994 9.64136C10.6694 9.64136 9.58838 10.7234 9.58838 12.0534C9.58838 13.3824 10.6694 14.4634 11.9994 14.4634C13.3294 14.4634 14.4114 13.3824 14.4114 12.0534C14.4114 10.7234 13.3294 9.64136 11.9994 9.64136ZM11.9994 15.9634C9.84238 15.9634 8.08838 14.2094 8.08838 12.0534C8.08838 9.89636 9.84238 8.14136 11.9994 8.14136C14.1564 8.14136 15.9114 9.89636 15.9114 12.0534C15.9114 14.2094 14.1564 15.9634 11.9994 15.9634Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1647",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 20,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.00024H21.9998V20.1052H2V4.00024Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1647)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.56975 12.0525C5.42975 16.1615 8.56275 18.6045 11.9998 18.6055C15.4368 18.6045 18.5697 16.1615 20.4298 12.0525C18.5697 7.94451 15.4368 5.50151 11.9998 5.50051C8.56375 5.50151 5.42975 7.94451 3.56975 12.0525ZM12.0017 20.1055H11.9978H11.9967C7.86075 20.1025 4.14675 17.2035 2.06075 12.3485C1.97975 12.1595 1.97975 11.9455 2.06075 11.7565C4.14675 6.90251 7.86175 4.00351 11.9967 4.00051C11.9987 3.99951 11.9987 3.99951 11.9998 4.00051C12.0017 3.99951 12.0017 3.99951 12.0028 4.00051C16.1388 4.00351 19.8527 6.90251 21.9387 11.7565C22.0208 11.9455 22.0208 12.1595 21.9387 12.3485C19.8537 17.2035 16.1388 20.1025 12.0028 20.1055H12.0017Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.415bbc0b2bd85c55a7c118a6af227920.svg";
export { ForwardRef as ReactComponent };